import { RoutingTabs, useRoutingTabs } from './useRoutingTabs';
import Stack from '@mui/material/Stack';
import { RoutingTabContent } from './RoutingTabContent';
import { useCallback } from 'react';
import { useSelector } from 'react-redux';
import { AutomationAssignmentsContextProvider } from './AutomationAssignmentsContextProvider';
import { AutomationScheduledAssignmentsContextProvider } from './AutomationScheduledAssignmentsContextProvider';
import { RoutingAutomationsContextWrapper } from './RoutingAutomationsContextWrapper';
import { RoutingContextProvider } from './RoutingContext';
import { selectDefaultCreationCrmOrgId } from '../../reducers/userInfoReducer';
import { MultipleRuleBuildersProvider } from '../common/sweep-condition-rule-builder/MultipleRuleBuildersContext';

const RoutingPage = () => {
  const crmOrgId = useSelector(selectDefaultCreationCrmOrgId);
  const { clearTab, changeTab, routingTab } = useRoutingTabs();

  const goToTab = (tab: RoutingTabs) => {
    changeTab(tab, crmOrgId ?? '');
  };

  const goToRoutingHome = useCallback(() => {
    clearTab(crmOrgId ?? '');
  }, [crmOrgId, clearTab]);

  return (
    <MultipleRuleBuildersProvider>
      <RoutingContextProvider>
        <Stack sx={{ pt: 4, height: '100%', gap: 3 }} data-testid="routing-page">
          <RoutingTabContent goToTab={goToTab} goToRoutingHome={goToRoutingHome} />

          {routingTab === RoutingTabs.assignment && (
            <AutomationAssignmentsContextProvider>
              <RoutingAutomationsContextWrapper
                goToRoutingHome={goToRoutingHome}
                isExpanded={true}
              />
            </AutomationAssignmentsContextProvider>
          )}

          {routingTab === RoutingTabs.scheduled && (
            <AutomationScheduledAssignmentsContextProvider>
              <RoutingAutomationsContextWrapper
                goToRoutingHome={goToRoutingHome}
                isExpanded={true}
              />
            </AutomationScheduledAssignmentsContextProvider>
          )}
        </Stack>
      </RoutingContextProvider>
    </MultipleRuleBuildersProvider>
  );
};

export { RoutingPage };
